// Generated using scripts/write-decode-map.ts

import { decodeBase64 } from "../internal/decode-shared.js";
export const xmlDecodeTree: Uint16Array = /* #__PURE__ */ decodeBase64(
    "AAJhZ2xxBwARABMAFQBtAg0AAAAAAA8AcAAmYG8AcwAnYHQAPmB0ADxg9SFvdCJg",
);
